import React, { useContext } from "react";
import SiteContext from "./SiteContext.jsx";
import PlatformContext from "./PlatformContext.jsx";

export default function RequestButton({ label = "Start Request", small = false }: { label?: string; small?: boolean }) {
  const { primaryColor } = useContext(SiteContext);
  const { platform } = useContext(PlatformContext);
  const previewFontClass = platform === "ios" ? "tw-font-previewIos tw-tracking-wide" : "tw-font-previewAndroid";

  return (
    <button
      tabIndex={-1}
      className={`
        ${previewFontClass}
        ${small ? "" : "tw-w-full"}
        tw-appearance-none
        tw-rounded-[4px]
        tw-border-0
        tw-bg-[var(--request-button-color)]
        tw-p-4
        tw-pl-10
        tw-pr-10
        tw-font-[inherit]
        tw-text-[16px]
        ${small ? "" : "tw-uppercase"}
        tw-text-white
        tw-shadow-md
      `}
      style={
        {
          "--request-button-color": primaryColor,
        } as React.CSSProperties
      }
    >
      {label}
    </button>
  );
}
